export default "__VITE_ASSET__D3xk$NBZ__"